/**
 * @typedef {Object} Badword
 * @property {string=} id
 * @property {string=} word
 * @property {boolean=} ignoreSpaces
 */

/**
 * @typedef {Object} BadwordService
 * @property {function(): angular.IPromise<Badword[]>} get
 * @property {function(string): angular.IPromise<Badword>} delete
 * @property {function(Badword): angular.IPromise<Badword>} post
 * @property {function(string, Badword): angular.IPromise<Badword>} patch
 */

const mod = require('../bahabot.module.js')

/**
 * @param {angular.resource.IResourceService} $resource
 * @param {angular.IQService} $q
 * @returns {BadwordService}
 */
function bahabotBadwordFactory($resource, $q) {
    const Badwords = $resource('/api/protected/badwords', {}, {
        get:    { method: 'GET' },
        post:   { method: 'POST' }
    });

    const Badword = $resource('/api/protected/badwords/:id', {}, {
        get:    { method: 'GET' },
        patch:  { method: 'PATCH' },
    });

    return {
        get: function() {
            return Badwords.get().$promise.then(res => res.data);
        },
        delete: function(id) {
            return Badword.delete({ id }).$promise.then(res => res.data)
        },
        patch: function(id, badword) {
            return Badword.patch({ id }, badword).$promise.then(res => res.data)
        },
        post: function(badword) {
            return Badwords.post(badword).$promise.then(res => res.data)
        }
    };
}

mod.factory('BadwordService', ["$resource", bahabotBadwordFactory]);
